function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _queued, _emitter, _isOpen, _socket, _handleMessage;

var _Symbol$for, _Symbol$for2;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var ee = require('namespace-emitter');

module.exports = (_queued = /*#__PURE__*/_classPrivateFieldLooseKey("queued"), _emitter = /*#__PURE__*/_classPrivateFieldLooseKey("emitter"), _isOpen = /*#__PURE__*/_classPrivateFieldLooseKey("isOpen"), _socket = /*#__PURE__*/_classPrivateFieldLooseKey("socket"), _handleMessage = /*#__PURE__*/_classPrivateFieldLooseKey("handleMessage"), _Symbol$for = Symbol.for('uppy test: getSocket'), _Symbol$for2 = Symbol.for('uppy test: getQueued'), /*#__PURE__*/function (_Symbol$for3, _Symbol$for4) {
  function UppySocket(opts) {
    var _this = this;

    _classCallCheck(this, UppySocket);

    Object.defineProperty(this, _queued, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _emitter, {
      writable: true,
      value: ee()
    });
    Object.defineProperty(this, _isOpen, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _socket, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _handleMessage, {
      writable: true,
      value: function value(e) {
        try {
          var message = JSON.parse(e.data);

          _this.emit(message.action, message.payload);
        } catch (err) {
          // TODO: use a more robust error handler.
          console.log(err); // eslint-disable-line no-console
        }
      }
    });
    this.opts = opts;

    if (!opts || opts.autoOpen !== false) {
      this.open();
    }
  }

  _createClass(UppySocket, [{
    key: "isOpen",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _isOpen)[_isOpen];
    }
  }, {
    key: _Symbol$for3,
    value: function value() {
      return _classPrivateFieldLooseBase(this, _socket)[_socket];
    }
  }, {
    key: _Symbol$for4,
    value: function value() {
      return _classPrivateFieldLooseBase(this, _queued)[_queued];
    }
  }, {
    key: "open",
    value: function open() {
      var _this2 = this;

      _classPrivateFieldLooseBase(this, _socket)[_socket] = new WebSocket(this.opts.target);

      _classPrivateFieldLooseBase(this, _socket)[_socket].onopen = function () {
        _classPrivateFieldLooseBase(_this2, _isOpen)[_isOpen] = true;

        while (_classPrivateFieldLooseBase(_this2, _queued)[_queued].length > 0 && _classPrivateFieldLooseBase(_this2, _isOpen)[_isOpen]) {
          var first = _classPrivateFieldLooseBase(_this2, _queued)[_queued].shift();

          _this2.send(first.action, first.payload);
        }
      };

      _classPrivateFieldLooseBase(this, _socket)[_socket].onclose = function () {
        _classPrivateFieldLooseBase(_this2, _isOpen)[_isOpen] = false;
      };

      _classPrivateFieldLooseBase(this, _socket)[_socket].onmessage = _classPrivateFieldLooseBase(this, _handleMessage)[_handleMessage];
    }
  }, {
    key: "close",
    value: function close() {
      var _classPrivateFieldLoo;

      (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _socket)[_socket]) == null ? void 0 : _classPrivateFieldLoo.close();
    }
  }, {
    key: "send",
    value: function send(action, payload) {
      // attach uuid
      if (!_classPrivateFieldLooseBase(this, _isOpen)[_isOpen]) {
        _classPrivateFieldLooseBase(this, _queued)[_queued].push({
          action: action,
          payload: payload
        });

        return;
      }

      _classPrivateFieldLooseBase(this, _socket)[_socket].send(JSON.stringify({
        action: action,
        payload: payload
      }));
    }
  }, {
    key: "on",
    value: function on(action, handler) {
      _classPrivateFieldLooseBase(this, _emitter)[_emitter].on(action, handler);
    }
  }, {
    key: "emit",
    value: function emit(action, payload) {
      _classPrivateFieldLooseBase(this, _emitter)[_emitter].emit(action, payload);
    }
  }, {
    key: "once",
    value: function once(action, handler) {
      _classPrivateFieldLooseBase(this, _emitter)[_emitter].once(action, handler);
    }
  }]);

  return UppySocket;
}(_Symbol$for, _Symbol$for2));